import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import JsonLd from '@/components/base/JsonLd';
import { updateDocumentMeta } from '@/components/base/SeoHelmet';
import HeroBanner from './components/HeroBanner';
import CategoryNav from './components/CategoryNav';
import FeaturedSection from './components/FeaturedSection';
import LatestSection from './components/LatestSection';
import FaqSection from './components/FaqSection';
import { home } from '@/i18n/local';

const homepageJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '红桃视频在线观看',
  url: 'https://www.hongtaovideo.com/',
  description: '红桃视频在线观看，提供海量高清视频资源，无需下载即点即播，支持手机、平板、电脑多端畅看。',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'https://www.hongtaovideo.com/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};

const orgJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: '红桃视频在线观看',
  url: 'https://www.hongtaovideo.com/',
  description: '免费高清视频播放平台',
  contactPoint: {
    '@type': 'ContactPoint',
    telephone: '400-888-0000',
    contactType: 'customer service',
    email: 'contact@hongtaovideo.com',
  },
};

const faqJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: home.faq.questions.map((item) => ({
    '@type': 'Question',
    name: item.q,
    acceptedAnswer: {
      '@type': 'Answer',
      text: item.a,
    },
  })),
};

export default function Home() {
  useEffect(() => {
    updateDocumentMeta(
      '红桃视频在线观看 - 免费高清视频播放平台',
      '红桃视频在线观看，提供海量高清视频资源，无需下载即点即播，支持手机、平板、电脑多端畅看。红桃视频在线观看体验流畅，内容丰富，每日更新，满足您的观影需求。',
      '红桃视频在线观看,红桃视频免费观看,红桃视频高清播放,红桃视频最新资源,红桃视频手机在线,红桃视频无广告播放',
      'https://www.hongtaovideo.com/'
    );
  }, []);

  return (
    <>
      <JsonLd data={homepageJsonLd} />
      <JsonLd data={orgJsonLd} />
      <JsonLd data={faqJsonLd} />
      <ScrollToTop />

      <div className="min-h-screen bg-background-50">
        <Navbar />

        <main>
          <HeroBanner
            title={home.hero.title}
            subtitle={home.hero.subtitle}
            description={home.hero.description}
            cta={home.hero.cta}
            stats={home.hero.stats}
          />

          <CategoryNav
            title={home.categoryNav.title}
            subtitle={home.categoryNav.subtitle}
          />

          <FeaturedSection
            title={home.featured.title}
            subtitle={home.featured.subtitle}
          />

          <LatestSection
            title={home.latest.title}
            subtitle={home.latest.subtitle}
            viewAll={home.latest.viewAll}
          />

          <FaqSection
            title={home.faq.title}
            subtitle={home.faq.subtitle}
            questions={home.faq.questions}
          />

          <section className="py-14 md:py-20 bg-gradient-to-r from-accent-100/80 via-primary-100/60 to-accent-100/80">
            <div className="max-w-[1440px] mx-auto px-4 md:px-6 text-center">
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
                {home.cta.title}
              </h2>
              <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
                {home.cta.subtitle}
              </p>
              <a
                href="/category/movie"
                className="inline-flex items-center gap-2 mt-8 px-8 py-3.5 rounded-full bg-primary-500 text-background-50 font-medium text-base hover:bg-primary-600 transition-all duration-300 hover:scale-105 whitespace-nowrap"
              >
                <i className="ri-play-fill"></i>
                {home.cta.button}
              </a>
            </div>
          </section>
        </main>

        <Footer />
      </div>
    </>
  );
}